import { useMemo } from "react";
import { useTable, usePagination, Column } from "react-table";

interface TableData {
  [key: string]: any;
}

interface TableProps {
  DATA: TableData[];
  COLUMNS: Column<TableData>[];
}

function TableComponent({ DATA, COLUMNS }: TableProps) {
  const columns = useMemo(() => COLUMNS, [COLUMNS]);
  const data = useMemo(() => DATA, [DATA]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,

    prepareRow,
    // @ts-ignore
    page, // For pagination
    // @ts-ignore
    canPreviousPage,
    // @ts-ignore
    canNextPage,
    // @ts-ignore
    pageOptions,
    // @ts-ignore
    gotoPage,
    // @ts-ignore
    nextPage,
    // @ts-ignore
    previousPage,
    // @ts-ignore
    setPageSize,
    // @ts-ignore
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      // @ts-ignore
      initialState: { pageIndex: 0, pageSize: 5 }, // Start from page 0
    },
    usePagination
  );

  return (
    <div className="w-full">
      {/* Table */}
      <table
        {...getTableProps()}
        className="w-full table-auto border-collapse text-right"
      >
        <thead className="w-full text-start bg-lightGold">
          {headerGroups.map((headerGroup: any) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="border-b border-[#E5E7EB]"
            >
              {headerGroup.headers.map((column: any) => (
                <th
                  {...column.getHeaderProps()}
                  className="whitespace-nowrap py-3 pl-6 pr-3 text-left text-sm font-semibold text-[#2A2E34]"
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="px-8">
          {page.map((row: any) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className="border-b border-[#E5E7EB] text-left"
              >
                {row.cells.map((cell: any) => (
                  <td
                    {...cell.getCellProps()}
                    className="py-3 pl-6 pr-3 text-sm text-gray-700"
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* {pageOptions?.length > 5 && (
        <div className="mt-8 flex w-full items-center justify-between">
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="flex h-[36px] w-[100px] items-center justify-center rounded-md border border-[#E5E7EB] bg-[#F9FAFB] text-sm font-normal text-[#111827]"
          >
            <img src={CHEVRON_LEFT} className="h-[20px] w-[20px]" alt="" />
            <span>Previous</span>
          </button>
          <div className="flex items-center gap-x-2">
            {pageOptions.map((_: any, index: number) => (
              <button
                onClick={() => gotoPage(index)}
                className="flex h-[36px] w-[36px] items-center justify-center rounded-md border border-[#E5E7EB] bg-[#F9FAFB]"
              >
                <span className="text-sm text-primary-default">{`0${index + 1}`}</span>
              </button>
            ))}
          </div>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="flex h-[36px] w-[100px] items-center justify-center rounded-md border border-[#E5E7EB] bg-[#F9FAFB] text-sm font-normal text-[#111827]"
          >
            <span>Next</span>
            <img
              src={CHEVRON_LEFT}
              className="h-[20px] w-[20px] scale-x-[-1]"
              alt=""
            />
          </button>
        </div>
      )} */}
    </div>
  );
}

export default TableComponent;
